if (!customElements.get('variant-bundle-picker')) {
  customElements.define(
    'variant-bundle-picker',
    class VariantBundlePicker extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.onChange);
        this.variantChangeUnsub = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        queueMicrotask(() => {
          const sub = this.querySelector('[data-bundle-subscription]');
          if (sub?.checked) this.syncSubscription(sub);
        });
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.variantChangeUnsub?.();
      }

      onVariantChange = (payload) => {
        const data = payload?.data;
        if (!data) return;
        const productInfo = this.closest('product-info');
        if (!productInfo || productInfo.dataset.section !== String(data.sectionId)) return;
        const variant = data.variant;
        if (!variant?.id) return;
        const radio = this.querySelector(`input[type="radio"][name^="variant-bundle-"][value="${variant.id}"]`);
        if (radio && !radio.checked) radio.checked = true;
        const sub = this.querySelector('[data-bundle-subscription]');
        if (sub?.checked) {
          this.applySubscriptionPriceDisplay(true);
          this.syncSellingPlanHidden(sub);
        }
      };

      onChange = (event) => {
        const target = event.target;

        if (target.matches('[data-bundle-subscription]')) {
          this.syncSubscription(target);
          return;
        }

        if (target.type !== 'radio' || !target.checked) return;
        if (!target.getAttribute('name')?.startsWith('variant-bundle-')) return;

        this.applyBundleSelectionToVariantSelects(target);
        const sub = this.querySelector('[data-bundle-subscription]');
        if (sub?.checked) {
          this.applySubscriptionPriceDisplay(true);
          this.syncSellingPlanHidden(sub);
        }
      };

      applyBundleSelectionToVariantSelects(bundleRadio) {
        const productInfo = this.closest('product-info');
        if (!productInfo) return;

        const vs = productInfo.querySelector('variant-selects');
        if (!vs) return;

        const ids = (bundleRadio.dataset.optionValueIds || '').split(',').filter(Boolean);
        if (!ids.length) return;

        let changeTarget = null;

        for (const optionValueId of ids) {
          const el = vs.querySelector(`[data-option-value-id="${CSS.escape(String(optionValueId))}"]`);
          if (!el) continue;

          if (el.tagName === 'OPTION') {
            const select = el.closest('select');
            if (!select) continue;
            Array.from(select.options).forEach((opt) => opt.removeAttribute('selected'));
            el.setAttribute('selected', 'selected');
            select.selectedIndex = Array.prototype.indexOf.call(select.options, el);
            changeTarget = select;
          } else if (el.matches?.('input[type="radio"]')) {
            el.checked = true;
            changeTarget = el;
          }
        }

        if (changeTarget) {
          changeTarget.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      syncSubscription(checkbox) {
        if (!checkbox) return;

        this.applySubscriptionPriceDisplay(checkbox.checked);
        this.syncSellingPlanHidden(checkbox);
      }

      applySubscriptionPriceDisplay(isSubscribed) {
        this.querySelectorAll('.variant-bundle__card').forEach((card) => {
          const radio = card.querySelector('input[type="radio"][name^="variant-bundle-"]');
          const priceEl = card.querySelector('.variant-bundle__price');
          if (!radio || !priceEl) return;
          const oneTime = radio.dataset.price || '';
          const sub = radio.dataset.subscriptionPrice || '';
          if (isSubscribed && sub) {
            priceEl.textContent = sub;
          } else {
            priceEl.textContent = oneTime;
          }
        });
      }

      getSellingPlanInput() {
        const fieldId =
          this.getAttribute('data-selling-plan-field-id') ||
          this.getAttribute('data-selling-price-field-id');
        if (!fieldId) return null;
        const byId = document.getElementById(fieldId);
        if (byId) return byId;
        const root = this.closest('product-info');
        return root?.querySelector(`#${CSS.escape(fieldId)}`) || null;
      }

      normalizeSellingPlanId(raw) {
        const s = (raw || '').trim();
        if (!s) return '';
        const m = s.match(/gid:\/\/shopify\/SellingPlan\/(\d+)/i);
        if (m) return m[1];
        return s;
      }

      /** Syncs hidden input name="selling_plan" with selected variant’s Shopify selling plan id (numeric). */
      syncSellingPlanHidden(checkbox) {
        if (!checkbox) return;

        const input = this.getSellingPlanInput();
        if (!input) return;

        if (!checkbox.checked) {
          input.value = '';
          input.setAttribute('disabled', 'disabled');
          return;
        }

        const selected = this.querySelector('input[type="radio"][name^="variant-bundle-"]:checked');
        const rawPlan = selected?.getAttribute('data-selling-plan-id')?.trim() || '';
        const planId = this.normalizeSellingPlanId(rawPlan);

        if (planId) {
          input.removeAttribute('disabled');
          input.value = planId;
        } else {
          input.value = '';
          input.setAttribute('disabled', 'disabled');
        }
      }
    }
  );
}
